import type { ChipProps } from "@heroui/react";
import { t } from "@lingui/core/macro";

type DisputeColor = ChipProps["color"];

/**
 * Dispute statuses where the merchant still has to act (submit evidence),
 * used to surface the chargeback more urgently.
 */
const ACTION_NEEDED_STATUSES = new Set([
  "needs_response",
  "warning_needs_response",
]);

export const isDisputeActionNeeded = (status: string): boolean =>
  ACTION_NEEDED_STATUSES.has(status);

export const getDisputeStatusLabel = (status: string): string => {
  switch (status) {
    case "warning_needs_response":
      return t`Opozorilo: potreben odgovor`;
    case "warning_under_review":
      return t`Opozorilo: v pregledu`;
    case "warning_closed":
      return t`Opozorilo zaprto`;
    case "needs_response":
      return t`Potreben odgovor`;
    case "under_review":
      return t`V pregledu`;
    case "won":
      return t`Dobljeno`;
    case "lost":
      return t`Izgubljeno`;
    case "charge_refunded":
      return t`Vrnjeno`;
    default:
      return status;
  }
};

export const getDisputeStatusColor = (status: string): DisputeColor => {
  switch (status) {
    case "won":
      return "success";
    case "needs_response":
    case "lost":
      return "danger";
    case "warning_closed":
    case "charge_refunded":
      return "default";
    default:
      return "warning";
  }
};

export const getDisputeReasonLabel = (reason: string): string => {
  switch (reason) {
    case "fraudulent":
      return t`Domnevna prevara`;
    case "duplicate":
      return t`Podvojeno plačilo`;
    case "credit_not_processed":
      return t`Vračilo ni bilo izvedeno`;
    case "product_not_received":
      return t`Izdelek ali storitev ni bila prejeta`;
    case "product_unacceptable":
      return t`Izdelek ali storitev je nesprejemljiv`;
    case "subscription_canceled":
      return t`Paket je bil preklican`;
    case "unrecognized":
      return t`Neprepoznana transakcija`;
    case "customer_initiated":
      return t`Sprožila stranka`;
    case "general":
      return t`Splošno`;
    default:
      return reason;
  }
};
